import { PsychiatryNoteSection } from '../components/PsychiatryNoteSection.component';
import * as Yup from 'yup';
import { Box, Typography } from '@mui/material';
import { CheckboxWithLabel, FormikAutoSave, NestedFormik } from '@uplift/ui-v2';
import { patchSession } from '@uplift/api';
import { useSessionQuery } from '@uplift/queries';
import { useQueryClient } from '@tanstack/react-query';
import { SectionPaper } from '../components/SectionPaper.component';

export type IdentityVerificationSectionProps = {
  sessionId: string;
  appointmentId: string;
};

export const IdentityVerificationSection: React.FC<IdentityVerificationSectionProps> = (props) => {
  const queryClient = useQueryClient();
  const { data: session } = useSessionQuery(props.sessionId);

  return (
    <NestedFormik
      name="identityVerification"
      enableReinitialize
      validationSchema={Yup.object().shape({
        identityVerified: Yup.bool().nullable().oneOf([ true ], ' ').required(' '),
      })}
      initialValues={{
        identityVerified: !!session?.identityVerifiedAt,
      }}
      onSubmit={async (values) => {
        await patchSession(props.sessionId, {
          identityVerified: values.identityVerified,
        });

        queryClient.invalidateQueries({ queryKey: [ 'session', props.sessionId ] });
        queryClient.invalidateQueries({ queryKey: [ 'appointment', props.appointmentId, 'session' ] });
      }}
    >
      {({ values, isValid }) => (
        <SectionPaper isError={isValid === false}>
          <PsychiatryNoteSection
            title={(
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <span>Client identity and informed consent</span>
                <Typography variant="body2">Insurance companies require that you confirm client identity in every session.</Typography>
              </Box>
            )}
          >
            <Box
              px={3}
              title={`Session ID: ${props.sessionId}`}
            >
              <FormikAutoSave
                onSave={async () => {
                  await patchSession(props.sessionId, {
                    identityVerified: values.identityVerified,
                  });
                }}
              />
              <CheckboxWithLabel
                showError
                name="identityVerified"
                label="I have confirmed the client's identity and obtained informed consent for telehealth therapy services"
                color="secondary"
              />
            </Box>
          </PsychiatryNoteSection>
        </SectionPaper>
      )}
    </NestedFormik>
  );
};
